import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { StyledTitle as Title } from '../../fields/Title';
import LaptopImage from '../../../assets/Laptop.png';
import { StyledButton } from '../../../styles/StyledComponents';
import { FormattedMessage } from 'react-intl';

export const EducatorsWhy = () => {
  return (
    <>
      <Row justify='center'>
        <Col
          xl={20}
          sm={22}
          style={{
            background: '#fff',
            padding: 40,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
          }}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 40 }}>
            {/* LEFT COLUMN */}
            <Col xl={12}>
              <img src={LaptopImage} alt='' />
              {/* <img src={PhoneImage} style={{width: 400, margin: '0 auto', display: 'block'}} alt="" /> */}
            </Col>
            {/* RIGHT COLUMN */}
            <Col xl={12}>
              <Title level={2} style={{ color: '#333', fontWeight: 'bolder' }}>
                <FormattedMessage id='why-tutorD.title' />
              </Title>
              <br />
              <strong style={{ color: '#333' }}>
                <FormattedMessage id='why-tutorD.subTitle' />
              </strong>
              <br />
              <br />
              <p>
                <FormattedMessage id='educators.main.descriptionOne' />
              </p>
              <p>
                <FormattedMessage id='educators.main.descriptionTwo' />
              </p>
            </Col>
          </Row>
          {/* PURPLE CONTAINER */}
          <Row justify='center' style={{ margin: '40px 0' }}>
            <Col
              xl={20}
              sm={22}
              style={{
                background: '#5BBCBD',
                borderRadius: 6,
                filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
                padding: 40
              }}
            >
              {/* ROW FOR TWO COLUMNS */}
              <Row justify='center' style={{ textAlign: 'center' }}>
                <Col>
                  <p style={{ color: '#fff', fontFamily: 'Montserrat Bold', fontSize: '3em' }}> <FormattedMessage id='educators-header.main.private-beta.title' /></p>
                  <p style={{ color: '#fff' }}>
                    <FormattedMessage id='educators.main.private-beta.subTitle' />
                  </p>
                  <br />
                  <StyledButton style={{ borderRadius: 6, height: 40, width: 150 }}>
                    <FormattedMessage id='educators-header.main.private-beta.demo-button' /> <RightOutlined />
                  </StyledButton>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
